import { IStore } from 'src/interfaces/store';
import { TSelectItem } from '../components/types';

/**
 * Maps the stores to a select item
 *
 * @param {IStore[]} stores
 * @return {*}  {TSelectItem[]}
 */
export const mapStores = (stores: IStore[]): TSelectItem[] =>
    stores.map((store) => ({
        value: store._id,
        label: store.name,
    }));
